/* Functional, tab-local navigation context. No tracking or network requests. */
(() => {
  const config = document.querySelector('script[data-vt-navigation]');
  if (!config) return;
  const pageType = config.dataset.pageType;
  const rootPath = new URL(config.dataset.rootUrl, location.origin).pathname;
  const pendingKey = 'vt-navigation-pending-v1';
  const returnKey = 'vt-navigation-return-v1';
  const activeKey = 'vt-navigation-active-v1';
  const maxAge = 30 * 60 * 1000;

  const read = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const write = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* Links still work. */ }
  };
  const remove = (key) => {
    try { sessionStorage.removeItem(key); } catch { /* Storage may be disabled. */ }
  };
  const localUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null;
    } catch { return null; }
  };
  const handle = (url) => url?.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  const isList = (url) => url && (
    url.pathname === rootPath || /\/collections\/[^/]+\/?$/.test(url.pathname) || /\/search\/?$/.test(url.pathname)
  );
  const validContext = (value) => value && typeof value.label === 'string' && isList(localUrl(value.url)) &&
    Number.isFinite(value.time) && Date.now() - value.time >= 0 && Date.now() - value.time < maxAge;
  const currentHandle = handle(new URL(location.href));
  const pending = read(pendingKey);
  remove(pendingKey);
  let context = null;
  if (pageType === 'product') {
    const hasExternalReferrer = document.referrer && !localUrl(document.referrer);
    if (!hasExternalReferrer && pending?.target === currentHandle &&
      Number.isFinite(pending.created) && Date.now() - pending.created >= 0 &&
      Date.now() - pending.created < 60000 && validContext(pending.context)) context = pending.context;
    const saved = read(activeKey);
    if (!context && performance.getEntriesByType('navigation')[0]?.type === 'reload' &&
      saved?.target === currentHandle && validContext(saved.context)) context = saved.context;
    const referrer = document.referrer ? localUrl(document.referrer) : null;
    if (!context && isList(referrer)) {
      context = {
        url: referrer.href,
        label: referrer.pathname === rootPath ? 'Volver al inicio' :
          /\/search\/?$/.test(referrer.pathname) ? 'Volver a los resultados' : 'Volver a la colección',
        time: Date.now()
      };
    }
    if (context) write(activeKey, { target: currentHandle, context });
    else remove(activeKey);
  }

  const updateLink = () => {
    if (!context || pageType !== 'product') return;
    document.querySelectorAll('[data-vt-return-link]').forEach((link) => {
      link.href = context.url;
      link.querySelector('[data-vt-return-label]').textContent = context.label;
    });
  };
  updateLink();
  document.addEventListener('shopify:section:load', updateLink);

  const restorePosition = () => {
    const saved = read(returnKey);
    remove(returnKey);
    if (!validContext(saved) || !Number.isFinite(saved.scroll)) return;
    const target = localUrl(saved.url);
    if (target.pathname + target.search !== location.pathname + location.search) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const card = Array.from(document.querySelectorAll('product-card[data-product-id]'))
        .find((item) => item.dataset.productId === saved.productId);
      const top = card && Number.isFinite(saved.offset)
        ? card.getBoundingClientRect().top + window.scrollY - saved.offset : saved.scroll;
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    }));
  };
  window.addEventListener('pageshow', restorePosition);

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
      !(event.target instanceof Element)) return;
    const back = event.target.closest('[data-vt-return-link]');
    if (back) {
      if (context) write(returnKey, { ...context, time: Date.now() });
      return; // Follow the real internal URL; never blindly call history.back().
    }
    if (event.target.closest('button, input, select, label, summary, [role="button"]')) return;
    const card = event.target.closest('product-card');
    const link = event.target.closest('a[href]') || card?.querySelector('[ref="productCardLink"]');
    const target = link && localUrl(link.href);
    if (!handle(target) || link.target === '_blank' || link.hasAttribute('download')) return;
    let source = context;
    if (['collection', 'search', 'index'].includes(pageType)) {
      const url = new URL(location.href);
      const cardPage = card?.closest('[data-page]')?.getAttribute('data-page');
      if (cardPage && /^\d+$/.test(cardPage) && Number(cardPage) > 0) {
        if (Number(cardPage) > 1) url.searchParams.set('page', cardPage);
        else url.searchParams.delete('page');
      }
      url.hash = '';
      const title = document.querySelector('main h1')?.textContent.trim();
      source = {
        url: url.href,
        label: pageType === 'index' ? 'Volver al inicio' : pageType === 'search' ?
          'Volver a los resultados' : title ? `Volver a ${title}` : 'Volver a la colección',
        scroll: window.scrollY,
        productId: card?.dataset.productId,
        offset: card?.getBoundingClientRect().top,
        time: Date.now()
      };
    }
    if (validContext(source)) write(pendingKey, { target: handle(target), context: source, created: Date.now() });
  }, true);
})();
